// extracted by mini-css-extract-plugin
export var actionText = "_hs-4";
export var container = "_hs-0";
export var leftSection = "_hs-1";
export var rightSection = "_hs-2";
export var settingsButton = "_hs-6";
export var settingsIcon = "_hs-7";
export var shortcut = "_hs-5";
export var shortcutGroup = "_hs-3";